import { ApolloError, gql, useMutation } from "@apollo/client";
import { DelMainCategoryMutation, DelMainCategoryMutationVariables } from "../generated/graphql";

const DEL_MAIN_CATEGORY_MUTATION = gql`
  mutation delMainCategory($input: DelMainCategoryInput!) {
    delMainCategory(input: $input) {
      ok
      err
    }
  }
`;

export const useDelMainCategory = (
    onCompleted?: (data: DelMainCategoryMutation) => void,
    onError?: (Error: ApolloError) => void
) => {
    return useMutation<DelMainCategoryMutation, DelMainCategoryMutationVariables>(
        DEL_MAIN_CATEGORY_MUTATION,
        {
            onCompleted,
            onError,
            
        }
    );
};